import DefineTokenContract from './tokenContract';
const _PurchaseABI = JSON.parse(
  '[{"constant":false,"inputs":[{"name":"data","type":"bytes"}],"name":"deploy","outputs":[{"name":"newContract","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newForwarder","type":"address"}],"name":"UpdateForwarder","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"sender","type":"address"},{"name":"paymentRequired","type":"uint256"},{"name":"contractData","type":"bytes"}],"name":"ForwardedDeployContract","outputs":[{"name":"deployedContract","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"PaymentAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"sender","type":"address"},{"name":"creationHash","type":"bytes32"}],"name":"ForwardedRefundContract","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"creationHash","type":"bytes32"},{"name":"amount","type":"uint256"}],"name":"PurchaseContract","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newPayer","type":"address"}],"name":"UpdatePaymentAddress","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"TokenContract","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"bytes32"}],"name":"Purchases","outputs":[{"name":"value","type":"uint256"},{"name":"blockPurchased","type":"uint256"},{"name":"purchasedBy","type":"address"},{"name":"blockRefunded","type":"uint256"},{"name":"blockDeployed","type":"uint256"},{"name":"deployedLocation","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"data","type":"bytes"}],"name":"getHash","outputs":[{"name":"creationHash","type":"bytes32"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":false,"inputs":[{"name":"creationHash","type":"bytes32"}],"name":"RefundContract","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"sender","type":"address"},{"name":"creationHash","type":"bytes32"},{"name":"amount","type":"uint256"}],"name":"ForwardedPurchaseContract","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"paymentRequired","type":"uint256"},{"name":"contractData","type":"bytes"}],"name":"DeployContract","outputs":[{"name":"deployedContract","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"sender","type":"address"},{"name":"newPayer","type":"address"}],"name":"ForwardedUpdatePaymentAddress","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"RefundAfter","outputs":[{"name":"","type":"uint128"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[{"name":"admin","type":"address"},{"name":"forwarder","type":"address"},{"name":"token","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"creationHash","type":"bytes32"},{"indexed":false,"name":"totalPaid","type":"uint256"}],"name":"PaymentMade","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"creationHash","type":"bytes32"},{"indexed":true,"name":"refundedTo","type":"address"}],"name":"RefundMade","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"creationHash","type":"bytes32"},{"indexed":true,"name":"deployedAt","type":"address"}],"name":"DeployedContract","type":"event"}]'
);
const _PurchaseAddress = '0x7c7d2d732fa758182adbb41425f06489b30cb74c';

function createPurchaseContractMethods(
  token_address,
  contract_address,
  _Web3,
  opts
) {
  if (typeof opts != 'object') {
    if (typeof opts != 'undefined') {
      throw new Error('Token Contract Options must be undefined or an object');
    } else {
      opts = {};
    }
  }

  if (typeof contract_address == 'undefined' || contract_address === null) {
    contract_address = _PurchaseAddress;
  }
  if (typeof contract_address != 'string') {
    throw new Error('Token Contract Address must be a String');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 Must be defined for Token Contract creation');
  } else {
    var PurchasesContract = {
      purchase: createPurchase(token_address, contract_address, _Web3, opts)
    };
    return PurchasesContract;
  }
}

function debugOut(debugToConsole, message) {
  if (debugToConsole) {
    console.log(message);
  }
}

function createPurchase(token_address, contract_address, _Web3, opts) {
  if (typeof opts != 'object') {
    opts = {};
  }
  if (typeof token_address != 'string') {
    throw new Error('Token Address must be a string');
  } else if (typeof contract_address != 'string') {
    throw new Error('Contract Address must be a string');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 must be an Object');
  } else {
    return purchase_contract;
  }

  var TokenContract;
  async function purchase_contract(codeHash, numTokens) {
    if (typeof codeHash != 'string') {
      throw new Error('Missing/Invalid codeHash');
    } else if (typeof numTokens != 'string' && typeof numTokens != 'number') {
      throw new Error('Missing/Invalid numTokens');
    } else {
      debugOut(opts.debug, 'Checking Token Allowance for Purchases Contract');
      TokenContract = DefineTokenContract(token_address, _Web3, opts);
      return(new Promise((resolve, reject)=>{
        
        function checkApprovalResult(error) {
          if (error) {
            resolve(error);
          } else {
            sendPurchaseTx(checkPurchaseResult);
          }
        }

        const checkPurchaseResult=(error, tx)=>{
          if(error){
            reject(error);
          }
          else
          {
            resolve(tx);
          }
        }

        TokenContract.checkAllowance(contract_address, (e, result)=>{
          if(e)
          {
            reject(e);
          }
          else if (result < numTokens) {
            debugOut(opts.debug, 'Sending Allowance Approval');
            TokenContract.approve(
              contract_address,
              numTokens,
              checkApprovalResult
            );
          } else {
            debugOut(
              opts.debug,
              'Contract is already allowed enough, skipping to purchase transaction'
            );
            sendPurchaseTx(checkPurchaseResult);
          }
        });
      }));
    }

    

    function sendPurchaseTx(callback) {
      var lastCall = false;
      var purchaseContract = _Web3.eth
        .contract(_PurchaseABI)
        .at(contract_address);
      debugOut(opts.debug, 'Checking Purchase');
      const purchasePrice = parseInt(numTokens);

      purchaseContract.PurchaseContract.call(
        codeHash,
        purchasePrice,
        {from: _Web3.eth.accounts[0], gas: 2000000},
        'latest',
        function(error, result) {
          debugOut(opts.debug, 'Checked Purchase');
          if (error) {
            return callback(error);
          } else if (typeof result == 'undefined') {
            return callback({error: 'Cannot complete Purchase'});
          } else {
            debugOut(opts.debug, 'Purchase Result: ' + result);
            debugOut(opts.debug, 'Purchasing Contract');
            purchaseContract.PurchaseContract.sendTransaction(
              codeHash,
              purchasePrice,
              {
                from: _Web3.eth.accounts[0],
                gas: 2000000
              },
              checkTransactionResult
            );
          }
        }
      );
      function checkTransactionResult(error, result) {
        if (!lastCall) {
          debugOut(opts.debug, 'Sent Purchase TX');
          lastCall = true;
          if (error) {
            console.error(error);
            return callback(error);
          } else {
            return callback(null, result);
          }
        }
      }
    }
  }
}

export default createPurchaseContractMethods;
